// import delPopIcon from '../../assets/del_pop_icon.svg';
import styles from './CancelTicket.module.scss';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

function CancelTicket({ show, context, handleClose, onConfirm, onCancel, message, loading }) {
  return (
    <Modal show={show} onHide={handleClose} className="delPopContainer" centered>
      <Modal.Body>
        <p>
          {message
            ? `${message}`
            : `Are you sure you want to delete this${context ? ' ' : ''}${context}?`}
        </p>
        <div className="btn_container">
          <Button className={styles.resetbtn} onClick={(e) => onCancel(e)}>
            Go Back
          </Button>
          <Button className={styles.deleteBtn} onClick={onConfirm} disabled={loading}>
            {loading ? 'Please wait...' : 'Yes, Cancel'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

CancelTicket.propTypes = {
  show: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  context: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.string,
};

CancelTicket.defaultProps = {
  context: '',
  message: '',
  loading: false,
};

export default CancelTicket;
